"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Style = exports.CSS = void 0;
const menu_style_1 = require("../../components/menu/menu.style");
exports.CSS = {
    container: 'c-AssignCollections',
    isLoading: 'c-AssignCollections--IsLoading',
    content: 'c-AssignCollections__Content',
    menu: 'c-AssignCollections__Menu'
};
exports.Style = {
    [exports.CSS.container]: {
        width: '600px'
    },
    [exports.CSS.isLoading]: {
        display: 'flex',
        'justify-content': 'center'
    },
    [exports.CSS.content]: {
        display: 'flex',
        'flex-direction': 'column',
        'align-items': 'start'
    },
    [exports.CSS.menu]: {
        width: '600px',
        position: 'absolute',
        [`& .${menu_style_1.CSS.menu}`]: {
            right: 'auto',
            width: '100%'
        }
    }
};
//# sourceMappingURL=user.assign.modal.style.js.map